import { Drawer, styled, Typography } from "@mui/material";
import { ProductForm } from "@features/products/components/forms/ProductForm/ProductForm";

interface CreateProductDrawerProps {
  open: boolean;
  onClose: () => void;
}

//Had to create a independant drawer in case a user wants to create a proucts
//When adding new stock

export const CreateProductDrawer = ({
  open,
  onClose,
}: CreateProductDrawerProps) => {
  return (
    <Drawer anchor={"right"} open={open} onClose={onClose}>
      <SideDrawerContainer>
        <Header>
          <Typography variant="h5">{"Create Product"}</Typography>
        </Header>
        <ProductForm handleClose={onClose} createFromStockView />
      </SideDrawerContainer>
    </Drawer>
  );
};

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 16px",
  height: "64px",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const SideDrawerContainer = styled("div")(({ theme }) => ({
  width: "100vw",
  position: "relative",
  height: "100%",
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up("lg")]: {
    width: "500px",
  },
}));
